import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/register']

router.beforeEach((to, from, next) => {
    NProgress.start()
    if (getToken() && getToken() != 'null') {
      const needChangePwd = store.getters.needChangePwd

      // 需强制改密：禁止进登录/注册绕过；业务路由放行，由全屏弹窗挡住操作
      if (needChangePwd) {
        if (to.path === '/login' || to.path === '/register') {
          next({ path: '/' })
          NProgress.done()
          return
        }
        next()
        return
      }

      if (to.path === '/login') {
        next({path: '/'})
      } else {
        if (store.getters.token.length === 0) {
          store.dispatch('FedLogOut').then(() => {
            next({path: '/login'})
          })
        } else {
            if (!to.path || to.path == '' || to.path == null) {
                to.path = "#";
            }
            if (to.path === '/login') {
                next({ path: '/' })
                NProgress.done()
            } else {
                next()
            }
        }
      }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
              next(`/login`)
              NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
